var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "category-list" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { attrs: { span: 14 } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "after-sales::email-setting::tag-add",
                      expression: "'after-sales::email-setting::tag-add'",
                    },
                  ],
                  staticClass: "new-menu-item",
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.handlerAddCateGory },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("after-sales::email-setting::email_tag_add")
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "right-box", attrs: { span: 10 } },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("after-sales::email-setting::email_tag_name")) +
                    "："
                ),
              ]),
              _c("el-input", {
                staticClass: "search-input",
                attrs: {
                  placeholder: _vm.$t(
                    "after-sales::email-setting::email_tag_name_holder"
                  ),
                  "prefix-icon": "el-icon-search",
                  clearable: "",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.init.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.params.categoryName,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "categoryName", $$v)
                  },
                  expression: "params.categoryName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "card-box", attrs: { gutter: 24 } },
        [
          _c(
            "el-col",
            { staticStyle: { "min-height": "600px" }, attrs: { span: 24 } },
            [
              _c("z-table", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                ref: "table",
                attrs: {
                  data: _vm.tableData,
                  "row-key": "id",
                  columns: _vm.columns,
                  "max-height": 560,
                  "tree-props": {
                    children: "childrens",
                    hasChildren: "hasChildren",
                  },
                  pagination: false,
                  customDefault: {
                    desc: _vm.$t("system::common::tips::quick_setting"),
                    buttons: [
                      {
                        btnClick: _vm.initSysTag,
                        text: _vm.$t(
                          "after-sales::email-setting::email_tag_init"
                        ),
                        type: "text",
                      },
                    ],
                  },
                },
                on: {
                  "expand-change": _vm.handleExpandChange,
                  "page-change": _vm.getListData,
                },
                scopedSlots: _vm._u([
                  {
                    key: "name",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.parentId === 0
                          ? _c(
                              "span",
                              {
                                staticClass: "tag-name",
                                class: { "ml-36": row.childrens.length === 0 },
                                style: "background: " + row.color,
                              },
                              [
                                !row.color
                                  ? _c("i", {
                                      staticClass: "iconfont iconnocolor",
                                    })
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _c("span", { class: { "ml-26": row.parentId !== 0 } }, [
                          _vm._v(_vm._s(row.name)),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "control",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "after-sales::email-setting::tag-edit",
                                expression:
                                  "'after-sales::email-setting::tag-edit'",
                              },
                            ],
                            staticClass: "btn-item",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleControl(row, "edit")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "after-sales::email-setting::email_tag_edit"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        row.level < 1
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "auth",
                                    rawName: "v-auth",
                                    value:
                                      "after-sales::email-setting::tag-edit",
                                    expression:
                                      "'after-sales::email-setting::tag-edit'",
                                  },
                                ],
                                staticClass: "btn-item",
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleControl(row, "next")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "after-sales::email-setting::email_tag_add_sub"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        !row.productCount && row.childrens.length === 0
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "auth",
                                    rawName: "v-auth",
                                    value:
                                      "after-sales::email-setting::tag-delete",
                                    expression:
                                      "'after-sales::email-setting::tag-delete'",
                                  },
                                ],
                                staticClass: "btn-item",
                                staticStyle: { color: "#FF0022" },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleControl(row, "delete")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "after-sales::email-setting::email_tag_delete"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("cateModal", {
        attrs: { visible: _vm.modal, cateData: _vm.cateInfoData },
        on: {
          "update:visible": function ($event) {
            _vm.modal = $event
          },
          save: _vm.handleSave,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }